import React, { useState, useEffect, useRef } from 'react';
import { observer } from 'mobx-react-lite';
import { useNavigate } from 'react-router-dom';
import sessionStore from '../stores/sessionStore';
import {
  TextField,
  Button,
  Typography,
  Link,
  Paper,
  Container,
  Alert,
  Box,
  Divider
} from '@mui/material';
import { Google as GoogleIcon } from '@mui/icons-material';
import { FaWhatsapp } from "react-icons/fa";
import { RiTelegram2Line } from "react-icons/ri";
import logger from '../utils/logger';

function Register() {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [captchaToken, setCaptchaToken] = useState('');
  const recaptchaRef = useRef(null);
  const widgetIdRef = useRef(null);

  // Инициализируем переводы при загрузке компонента
  useEffect(() => {
    const initI18n = async () => {
      // Если переводы еще не загружены
      
    };

    initI18n();
  }, []);

  useEffect(() => {
    if (sessionStore.user) {
      navigate('/');
    }
  }, [sessionStore.user, navigate]);

  useEffect(() => {
    window.onReCaptchaSuccess = onReCaptchaSuccess;

    // Функция инициализации shop reCAPTCHA
    const initReCaptcha = () => {
      if (window.grecaptcha && recaptchaRef.current) {
        try {
          widgetIdRef.current = window.grecaptcha.render(recaptchaRef.current, {
            sitekey: '6LfqCcQqAAAAALKgYqVYGGtP5ExM4AgrGCrLMtn-',
            callback: 'onReCaptchaSuccess',
          });
        } catch (error) {
          console.error('reCAPTCHA initialization error:', error);
        }
      }
    };

    // Если reCAPTCHA уже загружена
    if (window.grecaptcha && window.grecaptcha.ready) {
      window.grecaptcha.ready(initReCaptcha);
    } else {
      // Если не загружена, добавим обработчик события загрузки
      window.onloadCallback = initReCaptcha;
    }

    return () => {
      // Очистка при размонтировании
      if (window.grecaptcha && widgetIdRef.current !== null) {
        try {
          window.grecaptcha.reset(widgetIdRef.current);
        } catch (error) {
          console.error('reCAPTCHA reset error:', error);
        }
      }
    };
  }, []);

  const onReCaptchaSuccess = (token) => {
    setCaptchaToken(token);
  };

  const handleRegister = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    if (password !== confirm) {
      setError('Пароли не совпадают');
      setLoading(false);
      return;
    }

    if (!captchaToken) {
      setError('Подтвердите, что вы не робот');
      setLoading(false);
      return;
    }

    try {
      await sessionStore.registerByEmail(email, password);
    } catch (err) {
      logger.error(err);
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const handleGoogleRegister = async () => {
    setError('');
    setLoading(true);
    try {
      await sessionStore.loginByGoogle();
    } catch (err) {
      logger.error(err);
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container component="main" maxWidth="xs">
      <Paper elevation={3} style={{ padding: 20, marginTop: 40 }}>
        <Typography variant="h6" style={{ marginBottom: 20 }} sx={{ color: 'text.primary' }}>
        Calc5 - система расчета стоимости душевых кабин. <br />
        Модуль Производителя
        </Typography>

        <Typography variant="body1" style={{ marginBottom: 20, textAlign: 'center' }}>
          Регистрация
        </Typography>
        {error && (
          <Alert severity="error" style={{ marginBottom: 20 }}>
            {error}
          </Alert>
        )}
        <form onSubmit={handleRegister}>
          <TextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            label={'Email'}
            autoComplete="email"
            autoFocus
            size="small"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            disabled={loading}
          />
          <TextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            label={'Пароль'}
            type="password"
            size="small"
            autoComplete="new-password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            disabled={loading}
          />
          <TextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            label={'Подтвердите пароль'}
            type="password"
            autoComplete="new-password"
            size="small"
            value={confirm}
            onChange={(e) => setConfirm(e.target.value)}
            disabled={loading}
          />
          <div ref={recaptchaRef} style={{ margin: '20px 0' }} />
          <Button
            type="submit"
            fullWidth
            variant="contained"
            color="primary"
            style={{ margin: '24px 0 16px' }}
            disabled={loading}>
           Зарегистрироваться
          </Button>
        </form>
        <Button
          fullWidth
          variant="outlined"
          color="primary"
          startIcon={<GoogleIcon />}
          onClick={handleGoogleRegister}
          style={{ marginBottom: 16 }}
          disabled={loading}>
         Регистрация через Google
        </Button>
        <Typography style={{ marginBottom: 20 }}>
          Уже есть учетная запись?{' '}
          <Link href="/login" variant="body2">
            Войти
          </Link>
        </Typography>
        
        <Divider sx={{ my: 2 }} />
        
       
      
      </Paper>
    </Container>
  );
}

export default observer(Register);
